// Realistic mock data for the logged-in app shell (fictional).

export const COMPANIES = [
  { id: "acme-univ", name: "Acme University", country: "BR", lang: "pt" },
  { id: "certify-io", name: "Certify.io", country: "US", lang: "en" },
  { id: "ctf-league", name: "Global CTF League", country: "IT", lang: "it" },
  { id: "concurso-gov", name: "Órgão Público XYZ", country: "BR", lang: "pt" },
];

export const CURRENT_USER = {
  name: "Helena Ríos",
  email: "helena.rios@secproctoring.com",
  role: "Admin",
  initials: "HR",
};

const FIRST = ["Ana", "Bruno", "Chen", "Diego", "Emma", "Farid", "Giulia", "Hiro", "Ivan", "Júlia", "Kai", "Lena", "Marco", "Noa", "Omar", "Priya", "Rui", "Sara", "Tariq", "Vera"];
const LAST = ["Silva", "Rossi", "Kim", "López", "Müller", "Haddad", "Costa", "Yamada", "Petrov", "Souza", "Nguyen", "Okafor", "Bianchi", "Santos", "Khan", "Weber", "Moreau", "Dias", "Ali", "Novak"];

function uuid(i) {
  const h = (n) => n.toString(16).padStart(4, "0");
  return `${h(i * 7919)}-${h(i * 104729 % 65536)}-4${h(i % 4096).slice(1)}-a${h((i * 31) % 4096).slice(1)}-${h(i * 2654435761 % 65536)}${h(i * 40503 % 65536)}`;
}

export const EXAMS = [
  "AWS Security Specialty",
  "CISSP Recertification",
  "Concurso TRT — Analista",
  "OSCP Practical",
  "Cloud Architect Assoc.",
];
export const EVENTS = [
  "DEFCON Quals 2026",
  "HackTheNorth CTF",
  "OBSC 2026 — Etapa 1",
  "Enterprise RedTeam Cup",
];

const STATUSES = ["live", "recorded", "review", "done"];
const INTEGRITY = ["clean", "review", "flagged"];

export const SESSIONS = Array.from({ length: 42 }, (_, i) => {
  const isCtf = i % 3 === 0;
  const name = `${FIRST[i % FIRST.length]} ${LAST[(i * 3) % LAST.length]}`;
  const company = COMPANIES[i % COMPANIES.length];
  const status = STATUSES[i % STATUSES.length];
  const integrity = INTEGRITY[(i * 2) % INTEGRITY.length];
  return {
    id: uuid(i + 1),
    name,
    handle: isCtf ? `@${name.split(" ")[0].toLowerCase()}${i}` : null,
    exam: isCtf ? EVENTS[i % EVENTS.length] : EXAMS[i % EXAMS.length],
    isCtf,
    company: company.name,
    country: company.country,
    status,
    start: `2026-07-${String((i % 27) + 1).padStart(2, "0")} ${String((i % 12) + 8).padStart(2, "0")}:00`,
    durationMin: 45 + (i % 8) * 15,
    events: (i * 7) % 14,
    score: 100 - ((i * 13) % 42),
    integrity,
  };
});

// Sparkline / chart series for the dashboard.
export const SESSIONS_SERIES = Array.from({ length: 24 }, (_, h) => ({
  hour: `${String(h).padStart(2, "0")}:00`,
  sessions: Math.round(40 + 120 * Math.sin((h / 24) * Math.PI) + (h % 5) * 6),
  live: Math.round(10 + 50 * Math.sin((h / 24) * Math.PI)),
}));

export const RECENT_EVENTS = [
  { id: 1, sev: "critical", who: "Diego Costa", text: "Multiple people detected", cause: "client", time: "2 min" },
  { id: 2, sev: "high", who: "Emma Müller", text: "Tab switch during exam", cause: "client", time: "5 min" },
  { id: 3, sev: "medium", who: "Chen Kim", text: "Gaze off-screen 12s", cause: "client", time: "8 min" },
  { id: 4, sev: "info", who: "shard-03", text: "Renderer scaled to 6 workers", cause: "server", time: "11 min" },
  { id: 5, sev: "high", who: "Farid Haddad", text: "Secondary device detected", cause: "client", time: "14 min" },
  { id: 6, sev: "low", who: "Ana Silva", text: "Brief audio dropout", cause: "server", time: "20 min" },
];

export const SHARDS = [
  { id: "shard-01", sessions: 104, cpu: 62, status: "healthy" },
  { id: "shard-02", sessions: 98, cpu: 55, status: "healthy" },
  { id: "shard-03", sessions: 112, cpu: 78, status: "warning" },
  { id: "shard-04", sessions: 86, cpu: 41, status: "healthy" },
];

// Event Wall scoreboard (CTF)
export const SCOREBOARD = Array.from({ length: 12 }, (_, i) => ({
  rank: i + 1,
  handle: `@${FIRST[i % FIRST.length].toLowerCase()}_${LAST[i % LAST.length].toLowerCase()}`,
  name: `${FIRST[i % FIRST.length]} ${LAST[i % LAST.length]}`,
  country: ["BR", "US", "IT", "ES", "DE", "JP", "IN", "NG"][i % 8],
  points: 4800 - i * 320 - (i % 3) * 40,
  solved: 18 - i,
  lastSolve: `${(i % 9) + 1}m ago`,
}));

// Session review event markers (seconds → event)
export const REVIEW_EVENTS = [
  { t: 120, sev: "low", label: "Audio dropout" },
  { t: 340, sev: "medium", label: "Gaze off-screen" },
  { t: 610, sev: "high", label: "Tab switch" },
  { t: 905, sev: "critical", label: "Second face detected" },
  { t: 1180, sev: "medium", label: "Copy/paste event" },
  { t: 1520, sev: "info", label: "Bookmark added" },
];

export const KPIS = {
  activeSessions: 312,
  liveStreams: 27,
  openAlerts: 14,
  hoursRecorded: 18420,
  throughput: 742_000_000, // bps
};

export const IMPACT = {
  sessions: 2_400_000,
  hours: 5_800_000,
  frauds: 128_000,
  uptime: 99.98,
};
